(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.btabs').forEach(function (group) {
  var tabs = group.querySelectorAll('[data-btab]');
  var panels = group.querySelectorAll('[data-btab-panel]');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var i = tab.getAttribute('data-btab');

      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-btab') === i);
      });

      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-btab-panel') === i);
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
